<template>
  <div
    class="price"
    v-bind:class="color"
  >
    {{ price }}
  </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    color: String,
    price: Number,
  },
};
</script>

<style scoped>
.price {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'ONY Track', serif;
  font-weight: 900;
  font-size: 70px;
  line-height: 100%;
  text-transform: uppercase;
  width: 260px;
  height: 126px;
  border-radius: 24px;
}

.gray {
  background-color: #ACA29F;
  color: #1D1E1F;
}
.blue {
  background-color: #1A6BF9;
  color: #FFFFFF;
}
.green {
  background-color: #4AC84E;
  color: #1D1E1F;
}
.orange {
  background-color: #F7E543;
  color: #1D1E1F;
}
.red {
  background-color: #FF3E44;
  color: #FFFFFF;
}
</style>
